import React, { useEffect, useState } from 'react';
import Assignment from '@mui/icons-material/Assignment';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { CollapseCard, Button } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import FinancedOffersListItemComponent from '../components/FinancedOffersListItemComponent';
import FinancedOffersListItemComponentV2 from '../components/FinancedOffersListItemComponentV2';
import { withParams } from 'providers/ParamsConsumer';

export const FinancedOffersListComponent = ({
  t,
  financedOffers,
  openFinancedOffer,
  openOfferAsset,
  selectAssetsForContractGeneration,
  selectAssetsForContractGenerationV2,
  generateContract,
  generateSeparatedContractsChanged,
  generateSeparateContracts,
  params,
  folderStateCode
}) => {
  const contractGenerationStates = params?.contractGenerationStates?.split(';');
  const [genCtrButtonDisabled, setGenCtrButtonDisabled] = useState(true);

  useEffect(() => {
    var isDisabled = true;
    // eslint-disable-next-line
    financedOffers.map(offer => {
      // eslint-disable-next-line
      offer.assets.map(asset => {
        if (asset.selected === true) {
          isDisabled = false;
        }
        // eslint-disable-next-line
        asset.assetsAdditionalInformation.map(assetAdditionalInformation => {
          if (assetAdditionalInformation.selected === true) {
            isDisabled = false;
          }
        });
      });
    });

    var statePermitedForGeneration = contractGenerationStates?.includes(folderStateCode);
    setGenCtrButtonDisabled(isDisabled || !statePermitedForGeneration);
  }, [financedOffers, folderStateCode, contractGenerationStates]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CollapseCard icon={Assignment} iconColor='primary' title={t('Document.ContractGeneration.Title')} toggleOnHeaderClick>
      {financedOffers.length > 0 &&
        financedOffers.map(financedOffer => {
          if (!financedOffer.offerWithAssetAdditionalInformation) {
            return (
              <FinancedOffersListItemComponent
                key={financedOffer.offerId}
                financedOffer={financedOffer}
                openFinancedOffer={openFinancedOffer}
                openOfferAsset={openOfferAsset}
                selectAssetsForContractGeneration={selectAssetsForContractGeneration}
              />
            );
          } else {
            return (
              <FinancedOffersListItemComponentV2
                key={financedOffer.offerId}
                financedOffer={financedOffer}
                openFinancedOffer={openFinancedOffer}
                openOfferAsset={openOfferAsset}
                selectAssetsForContractGeneration={selectAssetsForContractGenerationV2}
              />
            );
          }
        })}
      <Grid container justifyContent='flex-end'>
        <FormControlLabel
          control={<Checkbox checked={generateSeparateContracts} onChange={generateSeparatedContractsChanged()} />}
          label={t('Document.ContractGeneration.CreateSeparatedContracts')}
        />
        <Button
          color='primary'
          onClick={generateContract}
          disabled={genCtrButtonDisabled}
          tooltip={genCtrButtonDisabled ? t('Document.ContractGeneration.CannotGenerateContract') : ''}
        >
          {t('Document.ContractGeneration.GenerateContract')}
        </Button>
      </Grid>
    </CollapseCard>
  );
};

FinancedOffersListComponent.propTypes = {
  financedOffers: PropTypes.array.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  selectAssetsForContractGeneration: PropTypes.func,
  selectAssetsForContractGenerationV2: PropTypes.func,
  openOfferAsset: PropTypes.func,
  t: PropTypes.func.isRequired,
  generateContract: PropTypes.func.isRequired,
  generateSeparatedContractsChanged: PropTypes.func.isRequired,
  generateSeparateContracts: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  folderStateCode: PropTypes.string.isRequired
};

export default compose(withTranslation())(withParams(FinancedOffersListComponent));
